module.exports = __webpack_public_path__ + "img/8dys-02.57d38389.png";